import React from 'react';
import _ from 'lodash';

import {
    Row,
    Col
} from 'reactstrap';


export default function ShowMoreButton({id, showMore, onClick}){
    return (
        <Row  className="my-1 mb-4">
            <Col className="d-flex justify-content-end" sm={12} md={12}>
                <a 
                    onClick={onClick} 
                    id={id? id: "showOptionalFields"}
                    color="link"
                    className="text"
                >
                    <u>
                    {showMore? "Hide" : "Show More"}  
                    <span className="ml-2">
                        <i 
                            className={
                                showMore? 
                                "fa fa-md fa-arrow-up": "fa fa-md fa-arrow-down"
                            }
                        ></i>
                    </span>
                    </u>
                </a>
            </Col>
        </Row>
    )
}